import Layout from "Layout"
import { useState, useEffect} from "react"
import { NavLink } from "react-router-dom"
import { mixGetV1 } from "services/mixin"
const Customer = () => {

    // Filter
    const [filterIndex, setFilterIndex] = useState(0)
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [statusFilter, setStatusFilter] = useState("all");
    const [search, setSearch] = useState("");
    const [total, setTotal] = useState(0);

    const getCustomers = async () => {
        try {
            let url = `/api/v1/be/customers?page=${page}&limit=10&sort[]=id,desc`;

            // lọc trạng thái
            if (statusFilter !== "all") {
                url += `&is_active=${statusFilter === "active" ? 1 : 0}`;
            }

            // lọc theo tên (API chuẩn của bạn)
            if (search.trim() !== "") {
                url += `&name=${encodeURIComponent(search)}`;
            }

            const res = await mixGetV1(url);

            if (res?.status) {
                setUsers(res.data.items);
                setTotal(res.data.total);  
            }

        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getCustomers();
    }, [page,statusFilter,search]);

    const filterBtn = [
        {
            name: 'Tất cả',
            class: 'bg-blue-500 text-white'
        },
        {
            name: 'Hoạt động',
            class: 'bg-green-500 text-white'
        },
        {
            name: 'Không hoạt động',
            class: 'bg-red-500 text-white'
        },
    ]
    // const handleClickFilter = (index: number) => {
    //     setFilterIndex(index)
    // }
    const handleClickFilter = (index: number) => {
        setFilterIndex(index);

        switch (index) {
            case 0:
                setStatusFilter("all");
                break;
            case 1:
                setStatusFilter("active");
                break;
            case 2:
                setStatusFilter("inactive");
                break;
        }
    };


    // Table
    const columns = [
        { title: "Họ và tên", key: "name" },
        { title: "Điện thoại", key: "phone" },
        { title: "Email", key: "email" },
        { title: "Ngày đăng ký", key: "date" },
        { title: "Trạng thái", key: "status" },
        { title: "Thao tác", key: "actions" },// nếu có nút bấm
    ];

    // const users = [
    //     {
    //         name: "Charlie Davis",
    //         phone: "+1 (555) 567-8901",
    //         email: "charlie.davis@example.com",
    //         date: "4/10/2025",
    //         status: 0
    //     },
    //     {
    //         name: "Bob Wilson",
    //         phone: "+1 (555) 345-6789",
    //         email: "bob.wilson@example.com",
    //         date: "19/9/2025",
    //         status: 0
    //     },
    //     {
    //         name: "Bob Wilson",
    //         phone: "+1 (555) 345-6789",
    //         email: "bob.wilson@example.com",
    //         date: "19/9/2025",
    //         status: 0
    //     },
    //     {
    //         name: "Bob Wilson",
    //         phone: "+1 (555) 345-6789",
    //         email: "bob.wilson@example.com",
    //         date: "19/9/2025",
    //         status: 1
    //     },
    //     {
    //         name: "Bob Wilson",
    //         phone: "+1 (555) 345-6789",
    //         email: "bob.wilson@example.com",
    //         date: "19/9/2025",
    //         status: 1
    //     },
    // ];

    return (
        <Layout>
            <div className="space-y-6">
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center">
                        <div className="relative flex-1 max-w-md">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-search absolute left-3 top-3/4 -translate-y-1/2 w-5 h-5 text-slate-400"
                            >
                                <circle cx={11} cy={11} r={8} />
                                <path d="m21 21-4.3-4.3" />
                            </svg>
                            <input
                                type="text"
                                placeholder="Tìm kiếm theo tên, email, số điện thoại..."
                                className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                // defaultValue=""
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setPage(1);
                                }}
                            />
                        </div>
                    </div>
                    <div
                        className="overflow-x-auto"
                        style={{
                            msOverflowStyle: 'none',
                            scrollbarWidth: 'none',
                        }}
                    >
                        <div className="flex items-center gap-2 w-full">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-filter w-5 h-5 text-slate-600"
                            >
                                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                            </svg>
                            <span className="whitespace-nowrap text-sm font-medium text-slate-700">
                                Trạng thái:
                            </span>
                            <div className="flex gap-2">
                                {filterBtn.map((item, index) => (
                                    <button
                                        key={index}
                                        onClick={() => handleClickFilter(index)}
                                        //className="px-3 py-1 text-sm rounded-lg transition-colors bg-blue-500 text-white"
                                        className={`whitespace-nowrap px-3 py-1 text-sm rounded-lg transition-colors ${filterIndex === index ? item.class : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`}
                                    >
                                        {item.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-slate-50 border-b border-slate-200">
                                <tr>
                                    {columns.map((item) => (
                                        <th key={item.key} className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                            {item.title}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-slate-200">
                                {users.map((user, index) => (
                                    <tr key={index} className="hover:bg-slate-50 transition-colors">
                                        {columns.map((col) => {
                                            if (col.key === 'name') {
                                                return (
                                                    <td key={col.key} className="px-6 py-4 whitespace-nowrap">
                                                        <div className="flex items-center gap-2">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={24}
                                                                height={24}
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                strokeWidth={2}
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                className="lucide lucide-user w-4 h-4 text-slate-400"
                                                            >
                                                                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                                                                <circle cx={12} cy={7} r={4} />
                                                            </svg>
                                                            <span className="text-sm font-medium text-slate-900">
                                                                {user.fullname ?? '---'}
                                                            </span>
                                                        </div>
                                                    </td>
                                                )
                                            }
                                            if (col.key === 'phone') {
                                                return (
                                                    <td key={col.key} className="px-6 py-4 whitespace-nowrap">
                                                        <div className="flex items-center gap-2">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={24}
                                                                height={24}
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                strokeWidth={2}
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                className="lucide lucide-phone w-4 h-4 text-slate-400"
                                                            >
                                                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                                            </svg>
                                                            <span className="text-sm text-slate-600">
                                                                 {user.phone ?? '---'}
                                                            </span>
                                                        </div>
                                                    </td>
                                                )
                                            }
                                            if (col.key === 'email') {
                                                return (
                                                    <td key={col.key} className="px-6 py-4 whitespace-nowrap">
                                                        <div className="flex items-center gap-2">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={24}
                                                                height={24}
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                strokeWidth={2}
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                className="lucide lucide-mail w-4 h-4 text-slate-400"
                                                            >
                                                                <rect width={20} height={16} x={2} y={4} rx={2} />
                                                                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                                                            </svg>
                                                            <span className="text-sm text-slate-600">
                                                                {user.email}
                                                            </span>
                                                        </div>
                                                    </td>
                                                )
                                            }
                                            if (col.key === 'date') {
                                                return (
                                                    <td key={col.key} className="px-6 py-4 whitespace-nowrap">
                                                        <div className="flex items-center gap-2">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={24}
                                                                height={24}
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                strokeWidth={2}
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                className="lucide lucide-calendar w-4 h-4 text-slate-400"
                                                            >
                                                                <path d="M8 2v4" />
                                                                <path d="M16 2v4" />
                                                                <rect width={18} height={18} x={3} y={4} rx={2} />
                                                                <path d="M3 10h18" />
                                                            </svg>
                                                            <span className="text-sm text-slate-600">
                                                                {user.created_at ? new Date(user.created_at).toLocaleDateString() : '---'}
                                                            </span>
                                                        </div>
                                                    </td>
                                                )
                                            }
                                            if (col.key === 'status') {
                                                return (
                                                    <td key={col.key} className="px-6 py-4 whitespace-nowrap">
                                                        {user.is_active === 1 ? (
                                                            <span className="px-2 py-1 text-green-600 bg-green-100 rounded-full text-xs">
                                                                Hoạt động
                                                            </span>
                                                        ) : (
                                                            <span className="px-2 py-1 text-red-600 bg-red-100 rounded-full text-xs">
                                                                Không hoạt động
                                                            </span>
                                                        )}
                                                        {/* {user.status === 0 ? (
                                                            <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-red-100 text-red-700 text-xs font-medium rounded-full">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width={24}
                                                                    height={24}
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    stroke="currentColor"
                                                                    strokeWidth={2}
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    className="lucide lucide-xcircle w-3 h-3"
                                                                >
                                                                    <circle cx={12} cy={12} r={10} />
                                                                    <path d="m15 9-6 6" />
                                                                    <path d="m9 9 6 6" />
                                                                </svg>
                                                                Không hoạt động
                                                            </span>
                                                        ) : (
                                                            <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width={24}
                                                                    height={24}
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    stroke="currentColor"
                                                                    strokeWidth={2}
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    className="lucide lucide-check-circle w-3 h-3"
                                                                >
                                                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                                                    <path d="m9 11 3 3L22 4" />
                                                                </svg>
                                                                Hoạt động
                                                            </span>
                                                        )} */}
                                                    </td>
                                                )
                                            }
                                            if (col.key === 'actions') {
                                                return (
                                                    <td key={col.key} className="px-6 py-4 whitespace-nowrap">
                                                        <div className="flex gap-2">
                                                            <NavLink to={`/khach-hang/chi-tiet/${user.id}`} className="text-xs font-medium px-3 py-1.5 rounded-lg transition-colors bg-blue-50 text-blue-600 hover:bg-blue-100 flex items-center gap-1">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width={24}
                                                                    height={24}
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    stroke="currentColor"
                                                                    strokeWidth={2}
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    className="lucide lucide-eye w-3 h-3"
                                                                >
                                                                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                                                                    <circle cx={12} cy={12} r={3} />
                                                                </svg>
                                                                Xem
                                                            </NavLink>
                                                            <button className="text-xs font-medium px-3 py-1.5 rounded-lg transition-colors bg-green-50 text-green-600 hover:bg-green-100">
                                                                Bật
                                                            </button>
                                                        </div>
                                                    </td>
                                                )
                                            }
                                            else {
                                                return (
                                                    <td key={col.key}> </td>
                                                );
                                            }
                                        })}



                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    <div className="flex justify-end gap-2 mt-4">
                        <button
                            disabled={page === 1}
                            onClick={() => setPage(page - 1)}
                            className="px-3 py-1 border rounded disabled:opacity-50"
                        >
                            &lt;
                        </button>

                        {[...Array(Math.ceil(total / 10))].map((_, i) => (
                            <button
                            key={i}
                            onClick={() => setPage(i + 1)}
                            className={`px-3 py-1 border rounded ${
                                page === i + 1 ? 'bg-blue-500 text-white' : ''
                            }`}
                            >
                            {i + 1}
                            </button>
                        ))}

                        <button
                            disabled={page * 10 >= total}
                            onClick={() => setPage(page + 1)}
                            className="px-3 py-1 border rounded disabled:opacity-50"
                        >
                            &gt;
                        </button>
                    </div>

                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Customer